import { storyQueryScope } from './storyQueryKeyBase';
import type { StoryQueryKey } from './storyQueryKeyBase';

const scope = storyQueryScope;

export const storyPropertyQueryKeys = Object.freeze({
  landing: Object.freeze({
    all: storyQueryScope('landing'),
    snapshot: (
      propertyId: string,
      authSessionKey: string,
      offerDecodeJobId?: string | null,
    ): StoryQueryKey =>
      scope(
        'landing',
        propertyId,
        'story-snapshot',
        authSessionKey,
        offerDecodeJobId ?? 'no-offer-context',
      ),
  }),
  property: Object.freeze({
    all: scope('property'),
    search: (query: string, bufferMeters: number): StoryQueryKey =>
      scope('property', 'search', query.trim(), bufferMeters),
    browseCandidates: (query: string, language: string, limit: number): StoryQueryKey =>
      scope('property', 'browse-candidates', query.trim(), language, limit),
    scope: (propertyId: string): StoryQueryKey => scope('property', propertyId),
    detail: (propertyId: string): StoryQueryKey => scope('property', propertyId, 'detail'),
    boundary: (propertyId: string): StoryQueryKey => scope('property', propertyId, 'boundary'),
    browseSnapshot: (propertyId: string): StoryQueryKey =>
      scope('property', propertyId, 'browse-snapshot'),
    relationship: (propertyId: string, sessionKey: string): StoryQueryKey =>
      scope('property', propertyId, 'relationship', sessionKey),
    portfolio: (sessionKey: string): StoryQueryKey => scope('property', 'portfolio', sessionKey),
    portfolioRanking: (sessionKey: string): StoryQueryKey =>
      scope('property', 'portfolio-ranking', sessionKey),
    portfolioRecord: (sessionKey: string, propertyId: string): StoryQueryKey =>
      scope('property', 'portfolio-ranking', sessionKey, 'record', propertyId),
    portfolioRankingAll: scope('property', 'portfolio-ranking'),
    subscriptions: (sessionKey: string): StoryQueryKey =>
      scope('property', 'subscriptions', sessionKey),
    forestContextScope: (propertyId: string): StoryQueryKey =>
      scope('property', propertyId, 'forest-context'),
    forestContext: (
      propertyId: string,
      bufferMeters: number,
      access: 'credentialed' | 'public' = 'credentialed',
    ): StoryQueryKey =>
      scope('property', propertyId, 'forest-context', bufferMeters, access),
    satelliteTimeline: (propertyId: string, history: 'latest' | 'full'): StoryQueryKey =>
      scope('property', propertyId, 'satellite-timeline', history),
    stormEvents: (propertyId: string): StoryQueryKey =>
      scope('property', propertyId, 'storm-events'),
    evidencePackage: (propertyId: string, eventDate: string, layer: string): StoryQueryKey =>
      scope('property', propertyId, 'evidence-package', eventDate, layer),
    overview: (
      propertyId: string,
      dataType: string,
      includeBiomass: boolean,
      includeGrowth: boolean,
    ): StoryQueryKey =>
      scope('property', propertyId, 'overview', dataType, includeBiomass, includeGrowth),
  }),
});
